import { IPendingEverifyRepository } from '../ports/outbound/IPendingEverifyRepository';
import { PendingEverifyResult } from '../domain/entities/PendingEverifyResult';
import { PendingEverifyFilter } from '../domain/entities/PendingEverifyFilter';
import { SortOrder } from "@/shared/application/domain/enums/SortOrder";

export class FetchPendingEverifyItemsUseCase {
  constructor(
    private readonly pendingEverifyRepository: IPendingEverifyRepository
  ) { }

  async execute(
    page: number,
    pageSize: number,
    columnName?: string,
    sortOrder?: SortOrder,
    filters?: PendingEverifyFilter
  ): Promise<PendingEverifyResult> {
    return this.pendingEverifyRepository.fetchPendingEverifyRecords(
      page,
      pageSize,
      columnName,
      sortOrder,
      filters
    );
  }
}
